import React from 'react'
import { useQuery } from 'jsonapi-react'
import TAG_ICONS from 'app/utils/tagIcons'
import Dropdown from 'app/theme/Dropdown'
import { Tag, ChevronDown } from 'react-feather'
import CuisineAutoComplete from 'app/theme/forms/CuisineAutoComplete'
import styles from './TagSelection.module.css'
export default function TagSelection({place, baseUrl, active}) {

  const maxMiles = 50

  const areaFilter = {}
  if ((place.type === 'city' && place.major) || !place.location) {
    areaFilter.city_id = place.id
  } else {
    areaFilter.city_id_or_service_area = JSON.stringify({
      city_id: place.id,
      service_area: { ...place.location, radius: maxMiles }
    })
  }

  const visibleFilter = {
    visible: JSON.stringify({
      city_filters: {
        visible: true,
      }
    })
  }

  const tagsQuery = useQuery(['tags', {
    sort: '-total_caterers',
    filter: {
      ...areaFilter,
      primary: true,
      ...visibleFilter
    },
    fields: {
      tags: ['name', 'slug', 'display_rules']
    },
    extra_fields: {
      tags: ['total_caterers']
    }
  }])

  const tags = tagsQuery?.data
  const isLoading = tagsQuery.isLoading

  if (!tags?.length || isLoading) {
    return null
  }

  return (
    <div>
      <p className="text-base pb-4">Popular Cuisines</p>
      {isLoading ? (
        <div className="flex items-center justify-center border rounded px-2 mr-2 mb-2">
          <Tag size={12}/> <label className="pl-2 text-sm font-light">Loading...</label>
        </div>
      ) : (
        <div className={[styles.tagBar, "flex flex-wrap relative"]}>
          <a className={[
            "flex items-center justify-center px-3 py-1 mr-2 mb-2 cursor-pointer",
            "border hover:border-blue font-light text-sm text-black",
            (!active ? "bg-blue-100" : "bg-white")
          ]} href={baseUrl + '/'}>All Cuisines</a>
          {tags.map((tag, index) => (
            <a
              key={index}
              href={baseUrl + '/' + tag.slug + '/'}
              className={[
                "flex items-center justify-center px-3 py-1 mr-2 mb-2 cursor-pointer",
                "border hover:border-blue",
                (active === tag.slug ? "bg-blue-100" : "bg-white")
              ]}
            >
              { TAG_ICONS[tag.slug] ? (
                <img src={TAG_ICONS[tag.slug]} style={{height:"1rem"}}/>
              ) : (
                <Tag size={12}/>
              )}
              <label
                className={[
                  "pl-2 text-sm text-black font-light cursor-pointer",
                ]}
              >
                {tag.name}
              </label>
            </a>
          ))}
          <div>
            <Dropdown>
              <Dropdown.Toggle
                className={[
                  "flex items-center justify-center px-3 py-1 mr-2 mb-2 cursor-pointer",
                  "border hover:border-blue bg-white font-light text-sm text-black",
                ]}
              >
                More <ChevronDown size={12} className="pt-1"/>
              </Dropdown.Toggle>
              <Dropdown.Content
                className={[
                  'bg-white border border-gray-300 shadow rounded p-4',
                  'font-light right-0',
                ]}
                style={{ width: "350px", top: "100%" }}
              >
                <p className="text-black font-bold mb-1">More Popular Cuisines</p>
                <div className={[styles.moreTags, "grid grid-cols-2 gap-2"]}>
                  {tags.map(tag => {
                    return (
                      <Dropdown.Item
                        key={tag.id}
                        className={[
                          "text-left text-black text-sm font-light flex items-center p-1",
                          (active === tag.slug ? "bg-blue-100" : "bg-white")
                        ]}
                      >
                        <a href={baseUrl + '/' + tag.slug + '/'}>
                          { TAG_ICONS[tag.slug] ? (
                            <img src={TAG_ICONS[tag.slug]} className="inline" style={{height:"1rem"}}/>
                          ) : (
                            <Tag size={12} className="inline"/>
                          )}
                          <p className="inline pl-1">{tag.name}</p>
                        </a>
                      </Dropdown.Item>
                    )
                  })}
                  {active ? (
                    <a href={baseUrl + '/1/'} className="text-black text-sm font-light">
                      <p className="inline pl-1">See All</p>
                    </a>
                  ) : null}
                </div>

                <CuisineAutoComplete place={place} baseUrl={baseUrl} filter={visibleFilter} />
              </Dropdown.Content>
            </Dropdown>
          </div>
        </div>
      )}
    </div>
  )
}
